export default __webpack_public_path__ + "static/Anton Suwandoro-ae92c22a6a9866915e6ec5b84f4c79b9.webp";